module.exports = __webpack_public_path__ + "img/Tool-frame.9f1938e3.svg";